// extracted by mini-css-extract-plugin
module.exports = {"Target":"Targets_Target__OAJQu","Holding":"Targets_Holding__2BHes"};